import React from 'react';
export function ProgressIndicator({
  current,
  total
}: {
  current: number;
  total: number;
}) {
  return <div className="flex items-center space-x-3 text-xs font-medium text-slate-400 uppercase tracking-wider mb-8" data-id="element-115">
      <span data-id="element-116">
        Step {current} of {total}
      </span>
      <div className="flex space-x-1.5 flex-1" data-id="element-117">
        {Array.from({
        length: total
      }).map((_, i) => <div key={i} className={`h-1 flex-1 rounded-full transition-colors duration-300 ${i < current ? 'bg-[#4B9FE1]' : 'bg-white/10'}`} data-id="element-118" />)}
      </div>
    </div>;
}